import React from "react";

const data = [
  { name: "Ibno Tofail", number: "0xxxxxxxx", email: "university@gmail.com" },
  {
    name: "Abdelmalek Essadi",
    number: "0xxxxxxxx",
    email: "university@gmail.com",
  },
  { name: "Al Kadi Aayad", number: "0xxxxxxxx", email: "university@gmail.com" },
  { name: "Al Akhawayn", number: "0xxxxxxxx", email: "university@gmail.com" },
];

const Recovery = () => {
  return (
    <div className="recovery_page">
      <h1>Please, contact your university to get your file Id</h1>
      <div className="table_page">
        <table>
          <tr>
            <th>University</th>
            <th>Phone number</th>
            <th>Email</th>
          </tr>
          {data.map((val, key) => {
            return (
              <tr key={key}>
                <td>{val.name}</td>
                <td>{val.number}</td>
                <td>{val.email}</td>
              </tr>
            );
          })}
        </table>
      </div>
    </div>
  );
};

export default Recovery;
